// 模組04 營運資訊(IP/專案/合約/廠商)+ 模組05 軟體 — mock 種子
// 專案/合約/廠商仍為 Sprint 2 殼層欄位;IP 已照 WF_v3(2375:30523)擴充(9月交付票 02)。

/**
 * IP 資訊(票 02,對稿 WF_v3):
 *   ip/parentIp(上一層)/mask/gateway/dns/mac/port(IP Port 位,SNMP 自動帶出)/
 *   iface(介面位置)/manager(IP 管理者)/source(SNMP|人工建檔)/keyBusiness(★關鍵業務)
 *   assets    已關聯資產快照(關聯當下由資產帶出,含位置 —— 列表「關聯設備/位置」
 *             由第一筆硬體資產推導,推導在 mock decorate,前端不自己算,ADR-0007)
 *   projects  已關聯專案;vendors 維護廠商(自合約關聯帶出,mock 直接給值)
 *   history   異動歷程(SNMP 探測列=系統自動寫入,不經審核)
 *   pendingAction 審核中的申請型別:create→列表「審核中|單號」/update→「異動中」
 */
/**
 * IP 資訊種子(票 9月交付/16 起照 `DcIpAddress` 契約的**語意**存):
 * - `managerId` → user store(DcCustomer)的 id;`manager_customer_name` 由投影查表帶出
 * - `assets[]` 是**關聯參照** `{ id: mappingId, assetType: "Hardware"|"Rack", assetId }`,
 *   資產明細(名稱/編號/廠牌/位置/管理者)由 hardware／cabinet store 投影時帶出 ——
 *   後端就是這樣(GetAssetMappings 34 鍵全是查出來的),mock 不再存第二份真相(ADR-0007)
 * - `pendingReview`＝SNMP 自動更新待人工確認(「異動中」,ConfirmReview 的對象);
 *   `approvalStatus: "pending"`＝審核單在途(「審核中｜單號」)。9/13 smoke:兩者是兩個欄位
 * - `history[]` 由審核引擎(`mock/approvals.js` appendIpHistory)回寫;`result` 值域照 swagger
 *   `DcIpAddressChangeLogDto.status_text`(已核准(結案)／審核中／已退回／系統自動寫入(不需簽核))
 * - ⚠️ `projects`／`vendors` 是 mock-only 的推算來源:後端列表的 support_project_name／
 *   maintenance_vendor_name 是「由關聯資產所屬專案／合約推算」,DcProject／DcVendor 未到位前
 *   mock 先從這裡取第一筆(待確認清單設計第 10 點)
 */
export const ips = [
  {
    id: 1, ip: "10.20.1.8", parentIp: "10.20.1.1", mask: "255.255.255.0", gateway: "10.20.1.254",
    dns: "10.20.1.10", mac: "00:1B:44:11:3A:B7", port: "Gi1/0/24", iface: "Eth0",
    managerId: 4, source: "SNMP", lastProbedOn: "2026-07-26T03:00:00", approvalStatus: "approved",
    assets: [
      { id: 1, assetType: "Hardware", assetId: 4 }, // SRV-A01-004 應用伺服器(R-A01・台北內湖)
      { id: 2, assetType: "Rack", assetId: 1 },     // R-A01
    ],
    projects: [
      { code: "PRJ-2026-001", name: "2026核心機房汰換案", manager: "林承翰", startDate: "2025-09-01", endDate: "2026-08-31" },
    ],
    vendors: ["宏益科技", "設備廠商"],
    history: [
      { at: "2026-08-05 14:22", by: "林承翰（EMP-0031）", kind: "異動",
        text: "關聯設定：新增關聯硬體 SRV-A01-004（應用伺服器），主要關聯不變",
        docNo: "RQ-20260805-012", result: "已核准(結案)" },
      { at: "2026-07-26 03:00", by: "系統", kind: "更新",
        text: "更新 IP Port 位：Gi1/0/23 → Gi1/0/24（探測值自動更新；與人工值不一致列入一致性校對差異報表）",
        docNo: null, result: "系統自動寫入(不需簽核)" },
      { at: "2026-06-12 10:02", by: "林承翰（EMP-0031）", kind: "新增",
        text: "建立 IP 10.20.1.8（關聯硬體 SRV-A01-004・主要）",
        docNo: "RQ-20260612-007", result: "已核准(結案)" },
    ],
  },
  {
    // SNMP 探測改了值、等人確認 → 「異動中」(不是審核單;列不凍結,可 ConfirmReview)
    id: 2, ip: "10.20.1.9", parentIp: "10.20.1.1", mask: "255.255.255.0", gateway: "10.20.1.254",
    dns: "10.20.1.10", mac: "00:1B:44:11:3A:B8", port: "Gi1/0/25", iface: "Eth1",
    managerId: 4, source: "SNMP", lastProbedOn: "2026-09-12T03:00:00", pendingReview: true, approvalStatus: "approved",
    assets: [{ id: 3, assetType: "Hardware", assetId: 2 }], // SRV-A01-002 資料庫主機
    projects: [
      { code: "PRJ-2026-001", name: "2026核心機房汰換案", manager: "林承翰", startDate: "2025-09-01", endDate: "2026-08-31" },
    ],
    vendors: ["宏益科技"],
    history: [
      { at: "2026-09-12 03:00", by: "系統", kind: "更新",
        text: "更新 Mac 資訊：00:1B:44:11:3A:B0 → 00:1B:44:11:3A:B8（探測值自動更新，待人工確認）",
        docNo: null, result: "系統自動寫入(不需簽核)" },
    ],
  },
  {
    id: 3, ip: "10.20.2.30", parentIp: "10.20.2.1", mask: "255.255.255.0", gateway: "10.20.2.254",
    dns: "10.20.1.10", mac: "00:1B:44:11:3A:C2", port: "Gi2/0/08", iface: "Eth0",
    managerId: 2, source: "SNMP", lastProbedOn: "2026-09-01T03:00:00", approvalStatus: "approved",
    assets: [{ id: 4, assetType: "Hardware", assetId: 6 }], // SRV-B02-002 防火牆主機(R-A02)
    projects: [],
    vendors: ["設備廠商"],
    history: [],
  },
  {
    // 掛在桃園青埔機房的機櫃上 —— 列表「機房篩選」要能只篩出這一筆
    id: 4, ip: "10.10.32.15", parentIp: "10.10.32.1", mask: "255.255.255.0", gateway: "10.10.32.254",
    dns: "10.10.30.5", mac: "00:1B:44:22:5C:01", port: "", iface: "Eth0",
    managerId: 34, source: "人工建檔", lastProbedOn: null, approvalStatus: "approved",
    assets: [{ id: 5, assetType: "Rack", assetId: 3 }], // R-B01(桃園青埔機房)
    projects: [
      { code: "PRJ-2026-004", name: "異地備援建置案", manager: "張家豪", startDate: "2025-11-01", endDate: "2026-12-31" },
    ],
    vendors: ["創唯科技"],
    history: [],
  },
  {
    id: 5, ip: "172.16.0.6", parentIp: "172.16.0.1", mask: "255.255.0.0", gateway: "172.16.0.254",
    dns: "", mac: "", port: "", iface: "",
    managerId: 5, source: "人工建檔", lastProbedOn: null, approvalStatus: "approved",
    assets: [], projects: [], vendors: [], history: [],
  },
  {
    id: 6, ip: "192.168.50.11", parentIp: "192.168.50.1", mask: "255.255.255.0", gateway: "192.168.50.254",
    dns: "", mac: "", port: "", iface: "Eth2",
    managerId: 34, source: "人工建檔", lastProbedOn: null, approvalStatus: "pending",
    pendingAction: "create", docNo: "RQ-20260609-003",
    assets: [], projects: [], vendors: [], history: [],
  },
];

export const projects = [
  { id: 1, name: "核心網路汰換 2026", owner: "林承翰（資訊處）", startDate: "2026-01-15", endDate: "2026-11-30", status: "進行中", approvalStatus: "approved" },
  { id: 2, name: "機房整併專案", owner: "張家豪（維運部）", startDate: "2026-03-01", endDate: "2026-08-15", status: "進行中", approvalStatus: "approved" },
];

/**
 * 合約資訊(票 04,對稿 WF_v3 2375:32205):
 *   code/name/manager/startDate/endDate/years/cycle(維護週期)/sla(服務等級)/amount/
 *   vendorName(服務廠商)/replyHours/arriveHours/fixHours(三時點)/contact/phone{...}/email/
 *   content(合約內容/用途)/mainChain(主要關聯合約:主約鏈)/linked(已關聯合約)/
 *   assets(資產關聯快照,同 IP)/maintenance(維護歷程月曆事件)/history(異動歷程)
 * 狀態(正常/剩N天/已逾期N天)由 endDate 於顯示時推導,不存欄位。
 */
/**
 * 合約種子(票 9月交付/33 起照 `DcContract` 契約的**語意**存;寫入側仍走舊 REST,所以文字欄照留):
 * - `managerId` → user store;`vendorName` → vendor store 查 id(DcVendor 未到,mock 自己查);
 *   `sla`／`cycle` 文字 → `db/contractLookups` 查 id
 * - `mainContractId`／`relations[]`(`{id, relatedId, type: Predecessor|Successor, isPrimary}`)取代原本存名字的
 *   mainChain／linked:後端只有 GetRelations 一種關聯、關聯只由上案(primary_related_contract_id)建立
 * - `assets[]` 是 `{id, assetType: Hardware|Rack|Software, assetId}` 參照(合約可掛三種),明細投影時查資產 store
 * - `maintenance[]` 照 `DcContractMaintenanceRecordDto` 語意:`{id, sequence, scheduledOn, statusId(0 未完成/1 已完成), description}`
 * - `history[]` result 值域照 swagger `DcContractChangeLogDto.status_text`(已核准(結案)／審核中／已退回／已取消)
 * - 4 號(消防)刻意沒有上案:「第一張合約 primary_related_contract_id 填什麼」是待確認清單的問題,mock 先允許 null
 */
export const contracts = [
  {
    id: 1, code: "CT-2026-031", name: "核心機房設備維護合約", managerId: 4, manager: "林承翰",
    startDate: "2026-01-01", endDate: "2026-12-31", years: 1, cycle: "季維護", sla: "7*24",
    amount: 2480000, vendorName: "宏益科技",
    replyHours: 1, arriveHours: 4, fixHours: 24,
    contact: "王大明", phone: { country: "+886", area: "02", number: "22222222", ext: "" },
    email: "email@com.tw",
    content: "核心機房伺服器、交換器與防火牆之年度維護,含季度到場保養與零件更換。",
    mainContractId: 4, mainContract: "CT-2025-090",
    relations: [
      { id: 1, relatedId: 4, type: "Predecessor", isPrimary: true },  // 上案:消防設備檢測合約(主約)
      { id: 2, relatedId: 2, type: "Successor", isPrimary: false },   // 下一案:空調
      { id: 3, relatedId: 3, type: "Successor", isPrimary: false },   // 下一案:UPS
    ],
    assets: [
      { id: 1, assetType: "Hardware", assetId: 4 }, // SRV-A01-004 應用伺服器
      { id: 2, assetType: "Rack", assetId: 1 },     // R-A01
    ],
    maintenance: [
      // 已完成的那次留一份附件:沒有任何一筆帶附件的話,`attachments[]` 的形狀永遠沒被驗到(票 39)
      { id: 1, sequence: 1, scheduledOn: "2026-08-13T09:00:00", statusId: 1, description: "季度到場保養(第 1 次)",
        // download_id 是整數(契約如此,DownloadMaintenanceAttachment 的路徑參數也是 int32)
        attachments: [{ downloadId: 9001, fileName: "20260813_保養報告.pdf", downloadUrl: "#/mock/attachment/9001" }] },
      { id: 2, sequence: 2, scheduledOn: "2026-08-21T09:00:00", statusId: 0, description: "季度到場保養(第 2 次)" },
    ],
    history: [
      { at: "2026-08-10 10:12", by: "吳佩珊（EMP-0121）", kind: "異動",
        text: "合約金額（附件缺報價單，補件後重送）", docNo: "RQ-20260810-006", result: "已退回" },
      { at: "2026-07-30 14:50", by: "吳佩珊（EMP-0121）", kind: "異動",
        text: "維護範圍：新增 備援資料庫（到期歷起算沿用・前 300 天）", docNo: "RQ-20260730-011", result: "已核准(結案)" },
      { at: "2026-06-03 13:26", by: "吳佩珊（EMP-0121）", kind: "異動",
        text: "關聯合約：新增下一案 CT-2026-045（空調設備年度維護合約）", docNo: "RQ-20260603-005", result: "已核准(結案)" },
      { at: "2026-04-08 09:00", by: "吳佩珊（EMP-0121）", kind: "新增",
        text: "建立合約 CT-2026-031（維護廠商：宏益科技股份有限公司）", docNo: "RQ-20260408-001", result: "已核准(結案)" },
    ],
    approvalStatus: "approved",
  },
  {
    id: 2, code: "CT-2026-045", mainContractId: 1, mainContract: "CT-2026-031", name: "空調設備年度維護合約", managerId: 4, manager: "林承翰",
    startDate: "2026-01-01", endDate: "2026-10-05", years: 1, cycle: "年維護", sla: "5*8",
    amount: 2480000, vendorName: "宏益科技",
    replyHours: 2, arriveHours: 8, fixHours: 48,
    contact: "王大明", phone: { country: "+886", area: "02", number: "22222222", ext: "" },
    email: "email@com.tw", content: "",
    relations: [{ id: 11, relatedId: 1, type: "Predecessor", isPrimary: true }],
    assets: [], maintenance: [], history: [],
    approvalStatus: "approved",
  },
  {
    id: 3, code: "CT-2026-052", mainContractId: 1, mainContract: "CT-2026-031", name: "UPS 不斷電系統維護合約", managerId: 4, manager: "林承翰",
    startDate: "2024-01-01", endDate: "2027-12-31", years: 3, cycle: "月維護", sla: "5*10",
    amount: 3600000, vendorName: "宏益科技",
    replyHours: 2, arriveHours: 6, fixHours: 36,
    contact: "王大明", phone: { country: "+886", area: "02", number: "22222222", ext: "" },
    email: "email@com.tw", content: "",
    relations: [{ id: 12, relatedId: 1, type: "Predecessor", isPrimary: true }],
    assets: [], maintenance: [], history: [],
    approvalStatus: "approved",
  },
  {
    // 第一張合約:沒有上案(待確認清單:primary_related_contract_id 必填時第一張怎麼填)
    id: 4, code: "CT-2025-090", mainContractId: null, mainContract: "", name: "消防設備檢測合約", managerId: 4, manager: "林承翰",
    startDate: "2023-07-01", endDate: "2026-08-04", years: 3, cycle: "半年維護", sla: "5*10",
    amount: 960000, vendorName: "宏益科技",
    replyHours: 4, arriveHours: 24, fixHours: 72,
    contact: "王大明", phone: { country: "+886", area: "02", number: "22222222", ext: "" },
    email: "email@com.tw", content: "",
    relations: [{ id: 13, relatedId: 1, type: "Successor", isPrimary: false }],
    assets: [], maintenance: [], history: [],
    approvalStatus: "approved",
  },
  // 舊種子保留:廠商刪除阻擋(創唯科技仍有合約)與既有測試對這兩列有依賴
  { id: 5, code: "CT-2026-001", mainContractId: 1, mainContract: "CT-2026-031", name: "機房維運服務合約 2026", managerId: 4, manager: "林承翰",
    startDate: "2026-01-01", endDate: "2026-10-15", years: 1, cycle: "季維護", sla: "7*24",
    amount: 1200000, vendorName: "創唯科技",
    replyHours: 1, arriveHours: 4, fixHours: 24,
    contact: "王經理", phone: { country: "+886", area: "02", number: "23456789", ext: "" },
    email: "service@trueway.com.tw", content: "",
    relations: [{ id: 14, relatedId: 1, type: "Predecessor", isPrimary: true }],
    assets: [], maintenance: [], history: [],
    approvalStatus: "approved" },
  {
    id: 6, code: "CT-2026-060", mainContractId: 1, mainContract: "CT-2026-031", name: "網路設備保固合約", managerId: 34, manager: "李宜潔",
    startDate: "2026-04-01", endDate: "2027-03-31", years: 1, cycle: "季維護", sla: "7*24",
    amount: 680000, vendorName: "神通資訊",
    replyHours: 1, arriveHours: 4, fixHours: 24,
    contact: "李工程師", phone: { country: "+886", area: "02", number: "87654321", ext: "" },
    email: "svc@mitac.com.tw", content: "",
    relations: [{ id: 15, relatedId: 1, type: "Predecessor", isPrimary: true }],
    assets: [], maintenance: [], history: [],
    approvalStatus: "pending", pendingAction: "create", docNo: "RQ-20260609-003",
  },
];

export const vendors = [
  { id: 1, name: "創唯科技", type: "系統整合", rating: "A", contact: "王經理", phone: "02-2345-6789", approvalStatus: "approved" },
  { id: 2, name: "神通資訊", type: "硬體維修", rating: "B", contact: "李工程師", phone: "02-8765-4321", approvalStatus: "approved" },
  // 合約種子四份都掛在這家(票 33 起合約列表的 vendor_id 由這裡查表,以前是孤兒名稱)
  { id: 3, name: "宏益科技", type: "維運", rating: "A", contact: "陳經理", phone: "02-2222-3333", approvalStatus: "approved" },
];

/**
 * 軟體資訊（DCK-05 軟體，Figma v2 `2128:25038`）。
 *
 * 欄位對齊 v2 列表:資產編號/Host Name・廠牌/型號・版號・部署設備數・
 * EOS・EOL・CVE・KEV・管理者。
 *
 * `deployedHardwareIds` 指向 db/assets.js 的硬體 —— 機房/機櫃/U 位由硬體那邊推導,
 * 不在這裡再存一份(展開列要顯示的位置資訊是同一個來源,重複存一定會漂移)。
 * `starred` 是列表上的★特別關注,與硬體同一個語意 —— 新增/編輯表單的「關鍵業務」
 * 寫的就是這個欄位(設計稿說「啟用後…加入星號」,兩個欄位遲早會對不起來)。
 *
 * 新增/編輯表單(Figma v2 `2128:26586`)另外用到這些欄位:
 *   基本:bizType・propertyNo・managerId・assetType・serialNo・env・remark
 *   資安:vulnerabilityHits[](每日比對命中的 CVE,唯讀,後端 DTO 形狀)・scan / pentest(弱掃、滲透測試)
 *   IP資訊分頁:ip・parentIp・ports[]
 */
export const software = [
  {
    id: 1, code: "SW-0001", name: "VMware vSphere",
    brand: "VMware", model: "vSphere Enterprise Plus", version: "8.0 U2",
    deployedHardwareIds: [1, 4],
    eos: "2027-10-31", eol: "2029-10-31",
    cveLevel: null, cveDate: null, kevLevel: null, kevDate: null,
    vulnerabilityHits: [],
    manager: "林承翰", managerId: 1, starred: false,
    bizType: "一類業務", assetType: "系統相關", env: "營運",
    propertyNo: "PRP-2024-0101", serialNo: "VS8-0001-AAAA-1111",
    remark: "虛擬化平台,全機房共用。",
    scan: { date: "", nextDate: "", rows: [] },
    pentest: { date: "", nextDate: "", rows: [] },
    ip: "10.10.32.15", parentIp: "10.10.32.1", ports: ["443/tcp", "902/tcp"],
    status: "使用中", approvalStatus: "approved",
  },
  {
    id: 2, code: "SW-0012", name: "Windows Server",
    brand: "Microsoft", model: "Windows Server Datacenter", version: "2019 Std",
    deployedHardwareIds: [2, 5, 6],
    // 四種風險都踩到的那一筆 —— 列表的風險欄與快速篩選要有東西可篩
    eos: "2026-06-30", eol: "2026-12-31",
    cveLevel: "嚴重", cveDate: "2026-06-30", kevLevel: "高", kevDate: "2026-12-31",
    // 命中清單(設計稿 `2198:58231` 的兩列範例):每日同步後依版本比對產生,唯讀。
    // **存後端 DTO 形狀**(DcAssetVulnerabilityHitDto,與硬體種子同一套;票 39)——
    // 原本存的是畫面形狀(cve/published/kevLevel),於是 mock 從來沒吐過契約上的
    // `vulnerability_hits`,軟體切真後端的那天走的會是完全沒被跑過的另一條路。
    vulnerabilityHits: [
      { cve_id: "CVE-2026-11884", severity: "嚴重", cvss_base_score: 9.1, category: "軟體(Windows Server)", is_kev: false,
        kev_date_added_utc: null, published_on_utc: "2026-05-14T00:00:00", is_platform_level: false,
        description: "Windows Server 遠端桌面服務遠端執行程式碼弱點",
        reference_url: "https://nvd.nist.gov/vuln/detail/CVE-2026-11884" },
      { cve_id: "CVE-2026-10233", severity: "高", cvss_base_score: 8.1, category: "軟體(Windows Server)", is_kev: true,
        kev_date_added_utc: "2026-06-10T00:00:00", published_on_utc: "2026-03-02T00:00:00", is_platform_level: false,
        description: "Windows Server SMB 用戶端權限提升弱點",
        reference_url: "https://nvd.nist.gov/vuln/detail/CVE-2026-10233" },
    ],
    manager: "林承翰", managerId: 1, starred: true,
    bizType: "一類業務", assetType: "系統相關", env: "營運",
    propertyNo: "PRP-2024-0112", serialNo: "WS19-DC-2222-3333",
    remark: "",
    // 弱掃／滲透測試各留已修補/未修補的列,修補狀態與備註兩欄才有東西可操作
    scan: {
      date: "2026-05-14", nextDate: "2026-11-14", rows: [
        { version: "2019 Std", patched: "Y", risk: "中", fileDate: "2025/12/3", note: "已套用 5 月累積更新" },
        { version: "2016 Std", patched: "N", risk: "高", fileDate: "2025/12/3", note: "" },
      ],
    },
    pentest: {
      date: "2026-04-02", nextDate: "2026-10-02", rows: [
        { version: "2019 Std", patched: "N", risk: "低", fileDate: "2025/12/3", note: "" },
      ],
    },
    ip: "10.10.32.16", parentIp: "10.10.32.1", ports: ["3389/tcp"],
    status: "使用中", approvalStatus: "approved",
  },
  {
    id: 3, code: "SW-0023", name: "Red Hat Enterprise Linux",
    brand: "Red Hat", model: "RHEL Server", version: "9.4",
    deployedHardwareIds: [3],
    eos: "2030-06-30", eol: "2030-06-30",
    cveLevel: null, cveDate: null, kevLevel: null, kevDate: null,
    vulnerabilityHits: [],
    manager: "張家豪", managerId: 2, starred: false,
    bizType: "二類業務", assetType: "系統相關", env: "測試",
    propertyNo: "", serialNo: "RHEL94-4444-5555",
    remark: "",
    scan: { date: "", nextDate: "", rows: [] },
    pentest: { date: "", nextDate: "", rows: [] },
    ip: "10.10.33.20", parentIp: "", ports: [],
    status: "使用中", approvalStatus: "approved",
  },
  {
    // 還沒部署到任何設備 —— 列表的「部署設備數 0 台」與展開後的空狀態要有樣本
    id: 4, code: "SW-0031", name: "Oracle Database",
    brand: "Oracle", model: "Database Enterprise", version: "19c",
    deployedHardwareIds: [],
    eos: "", eol: "",
    cveLevel: null, cveDate: null, kevLevel: null, kevDate: null,
    vulnerabilityHits: [],
    manager: "林承翰", managerId: 1, starred: false,
    bizType: "三類業務", assetType: "軟體相關", env: "開發",
    propertyNo: "", serialNo: "ORA19C-6666-7777",
    remark: "採購完成,尚未安裝。",
    scan: { date: "", nextDate: "", rows: [] },
    pentest: { date: "", nextDate: "", rows: [] },
    ip: "10.10.34.10", parentIp: "", ports: [],
    status: "閒置", approvalStatus: "approved",
  },
  {
    // 審核中 —— 列表要顯示「審核中｜單號」且操作欄的編輯/刪除要停用
    id: 5, code: "SW-0044", name: "Nginx",
    brand: "F5", model: "NGINX Plus", version: "R32",
    deployedHardwareIds: [1],
    eos: "", eol: "",
    cveLevel: null, cveDate: null, kevLevel: null, kevDate: null,
    vulnerabilityHits: [],
    manager: "林承翰", managerId: 1, starred: false,
    bizType: "一類業務", assetType: "系統相關", env: "DMZ區域",
    propertyNo: "", serialNo: "NGXP-R32-8888",
    remark: "",
    scan: { date: "", nextDate: "", rows: [] },
    pentest: { date: "", nextDate: "", rows: [] },
    ip: "10.10.35.5", parentIp: "", ports: ["80/tcp", "443/tcp"],
    status: "使用中",
    docNo: "SW-2026-0044", approvalStatus: "pending",
  },
];
